<template>
  <AhaPage id="not-found-page">
    <AhaHeader>
      <MainHeader />
    </AhaHeader>

    <AhaContent>
      <div class="not-found-page">
        <div class="w-full">
          <h2 class="font-bold">
            There's nothing to see here!
          </h2>
          <p class="text-sm text-opacity-40">
            If you got this link from someone, please ask them to provide you with a new link.
          </p>
        </div>
      </div>
    </AhaContent>
  </AhaPage>
</template>

<script>
// components
import MainHeader from '@/components/main/MainHeader.vue'

export default {
  components: {
    MainHeader,
  },
}
</script>

<style lang="scss" scoped>
.not-found-page {
  @apply w-full h-full text-base-0 flex items-center text-center;

  h2 {
    margin-bottom: 20px;
  }

  p {
    color: rgba(255, 255, 255, 0.42);
  }
}

#not-found-page {
  @apply bg-secondary-100;
}
</style>
